<template>
    <div class="counter-guide" v-if="showCounter">
        <div class="text">{{ textLeft }}</div>
        <div class="counter">
            <div class="counters-items">
                <div class="days">
                    <div class="number">{{ days | digits }}</div>
                    <span>{{ trans.days }}</span>
                </div>
                <div class="hours">
                    <div class="number">{{ hours | digits }}</div>
                    <span>{{ trans.hours }}</span>
                </div>
                <div class="minutes">
                    <div class="number">{{ minutes | digits }}</div>
                    <span>{{ trans.minutes }}</span>
                </div>
                <div class="seconds">
                    <div class="number">{{ seconds | digits }}</div>
                    <span>{{ trans.seconds }}</span>
                </div>
            </div>
        </div>
        <div class="text">{{ textRight }}</div>
    </div>
</template>

<script>
export default {
    props: {
        date: {
            type: String,
            required: true,
        },
        trans: {
            type: Object,
            default: () => ({
                days: 'DIAS',
                hours: 'HRS',
                minutes: 'MIN',
                seconds: 'SEG'
            })
        },
        textLeft: {
            type: String,
            default: 'FALTAM'
        },
        textRight: {
            type: String,
            default: 'PARA O CARNAVAL DO RIO.'
        }
    },

    filters: {
        digits(value) {
            return value < 10 ? '0' + value : value;
        }
    },

    mounted() {
        this.interval = window.setInterval(() => {
            this.now = Math.trunc((new Date()).getTime() / 1000);
        }, 1000);
    },

    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    },

    data() {
        return {
            now: Math.trunc((new Date()).getTime() / 1000),
            end: Math.trunc(Date.parse(this.date) / 1000),
            interval: null
        }
    },

    computed: {
        showCounter() {
            return this.end > this.now;
        },

        seconds() {
            return Math.max(0, (this.end - this.now) % 60);
        },

        minutes() {
            return Math.max(0, Math.trunc((this.end - this.now) / 60) % 60);
        },

        hours() {
            return Math.max(0, Math.trunc((this.end - this.now) / 60 / 60) % 24);
        },

        days() {
            return Math.max(0, Math.trunc((this.end - this.now) / 60 / 60 / 24));
        }
    }
}
</script>

<style lang="scss" scoped>
.counter-guide {
    background: #EF7041;
    color: #FFF;
    width: 100%;
    max-width: 788px;
    margin: 0 auto;
    box-shadow: 0px 0px 10px 6px rgba(0, 0, 0, .16);
    padding: 24px 8px 16px;
    text-align: center;

    @media (min-width: 992px) {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        z-index: 1;
        border-radius: 10px;
        margin-top: -43px;
    }

    .text {
        text-transform: uppercase;
        font-size: 18px;
        margin: 0 8px;
        color: #FFF;
        font-weight: bold;
        text-align: center;
    }

    .counter {
        padding: 14px 8px;

        @media (min-width: 992px) {
            padding: 0 8px;
        }
    }

    .counters-items {
        display: flex;
        justify-content: center;
        margin-top: 0;
        width: 240px;

        > div {
            color: #FFF;
            font-size: 8px;
            width: auto;
            position: relative;
            margin: 0 4px;

            &:before {
                content: '';
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                top: -8px;
                border-radius: 8px;
                border: 2px solid #FFF;
                opacity: .5;
                width: calc(100% + 8px);
                height: 48px;
                min-width: 54px;
            }
        }

        .number {
            font-size: 31px;
            line-height: 1em;
            font-weight: 900;
            margin-bottom: 2px;
        }

        span {
            display: block;
            background: #EF7041;
            position: relative;
            width: 44px;
            margin: 0 auto;
        }
    }
}
</style>
